import React from 'react';

/**
 * Action chip inside the morning briefing card. `accent` = solid violet pill,
 * otherwise ghost with rule border.
 */

export interface BriefingChipProps {
  label: string;
  onClick?: () => void;
  accent?: boolean;
}

export function BriefingChip({ label, onClick, accent = false }: BriefingChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        padding: '7px 12px',
        fontSize: 13,
        fontFamily: 'var(--font-ui)',
        fontWeight: 500,
        whiteSpace: 'nowrap',
        color: accent ? 'var(--on-accent)' : 'var(--ink)',
        background: accent ? 'var(--accent)' : 'var(--paper)',
        border: `1px solid ${accent ? 'var(--accent)' : 'var(--rule)'}`,
        borderRadius: 8,
        cursor: 'pointer',
        transition: 'transform 150ms ease, filter 150ms ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-1px)';
        if (accent) e.currentTarget.style.filter = 'brightness(1.08)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.filter = 'none';
      }}
    >
      {label}
    </button>
  );
}
